/**
 * @packageDocumentation
 * @module      RoboticNetworkDto.ts
 * @description Models the Data-Transfer Object for saving a robotic network
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class RoboticNetworkDto {
    constructor(roboticNetwork) {
        this.systemIds = [];
        this.roboticNetworkId = roboticNetwork.roboticNetworkId;
        this.roboticNetworkName = roboticNetwork.roboticNetworkName;
        this.systemIds = roboticNetwork.systems.map((s) => s.systemId);
    }
    toJSON() {
        const jsonObj = Object.assign({}, this);
        jsonObj.roboticNetworkId = this.roboticNetworkId;
        jsonObj.roboticNetworkName = this.roboticNetworkName;
        jsonObj.systemIds = this.systemIds;
        return jsonObj;
    }
}
//# sourceMappingURL=RoboticNetworkDto.js.map